import { encryptValue } from "../../../utils/common";
import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "./apiService";

  const createPermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.createPermission}`,
      method: "POST",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const addAccessRoute = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.addAccessRoute}`,
      method: "POST",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getAllRoutes = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getAllRoutes}`,
      method: "GET",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getRoutesPermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getRoutesPermission}`,
      method: "GET",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getMenuPermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getMenuPermission}`,
      method: "GET",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getMenuRoutesPermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getMenuRoutesPermission}`,
      method: "GET",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getPermissionConstant = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getPermissionConstant}`,
      method: "GET",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getCategoryWisePermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getCategoryWisePermission}`,
      method: "GET",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const updatePermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.updatePermission}`,
      method: "POST",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getRoleOrUserWisePermission = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getRoleOrUserWisePermission}`,
      method: "GET",
      params: params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


  const getNotificationEvents = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.notification.getNotificationEvents}`,
      method: "GET",
      params: params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


  const updateCommunication = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.notification.updateCommunication}`,
      method: "POST",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


 
 
  export default {
    createPermission,
    addAccessRoute,
    getAllRoutes,
    getRoutesPermission,
    getMenuPermission,
    getMenuRoutesPermission,
    getPermissionConstant,
    getCategoryWisePermission,
    updatePermission,
    getRoleOrUserWisePermission,
    getNotificationEvents,
    updateCommunication
  }